<template>
  <div>
    <v-menu
      v-if="!readonly"
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="model"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template #activator="{ on, attrs }">
        <div class="cfs-field d-flex flex-column" :class="{ 'static-bg': staticBg }">
          <p class="input-title px-1 pb-1" :class="{ disabled }">{{ label }}</p>
          <v-text-field
            v-bind="attrs"
            ref="outer"
            :value="value"
            class="cfs-date-input"
            :placeholder="inputText"
            readonly
            outlined
            :disabled="disabled"
            append-icon="mdi-clock-time-five-outline"
            dense
            hide-details
            v-on="on"
            @click:append="outerClickHandler"
          />
          <small v-if="hint.length && disabled" class="pl-2 text--secondary"> * {{ hint }} </small>
        </div>
      </template>
      <v-time-picker
        v-model="model"
        no-title
        format="ampm"
        landscape
        scrollable
        color="primary"
        flat
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancel">{{ $t('Clear') }}</v-btn>
        <v-btn text color="primary" @click="save(model)">{{ $t('OK') }}</v-btn>
      </v-time-picker>
    </v-menu>
    <CfsReadonlyField v-else v-bind="$props" :value="model" />
  </div>
</template>

<script>
export default {
  components: {
    CfsReadonlyField: () => import('./special/CfsReadonlyFieldComponent.vue'),
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    /**when set to false fills input with application background solid color instead of inherited one.
     * I.e. removes transparency from input*/
    staticBg: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: this.value,
      inputText: this.placeholder || this.$t('HH:MM'),
      menu: false,
    };
  },
  methods: {
    save() {
      this.$refs.menu.save(this.model);
      this.$emit('ok', this.model);
      this.$emit('change', this.model);
    },
    cancel() {
      this.menu = false;
      this.model = null;
      this.save();
    },
    outerClickHandler() {
      this.$refs.outer.$el.querySelector('input').click();
    },
  },
};
</script>
